import React from "react"
import { Box } from "@mui/system"
import { Stack, Typography } from "@mui/material"
import { Footer, Header } from "../../components"

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import useStyles, { StyledAccordian, StyledDiv } from "./styles";
import { frequentQuestions } from "./questions";

export function FundraisingQAs() {
    const classes = useStyles();
    const mapQuestions = () => {
        return frequentQuestions.map(question => {
            return <Box className={classes.questionsDiv}>
            <Typography gutterBottom variant="h5">{question.type}</Typography>
            {
                question.data.map(data => {
                    return <StyledAccordian>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography>{data.question}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography dangerouslySetInnerHTML={{__html: data.answer}}></Typography>
                    </AccordionDetails>
                </StyledAccordian>
                })
            }
        </Box>
        })
    }
    return <React.Fragment>
        <Header />
        <Stack spacing={8} className={classes.flexBox}>
            <StyledDiv>
                <Typography gutterBottom variant="h4">Frequently Asked Questions</Typography>
                <Typography variant="subtitle">Learn more about fundraising, donating or receiving donations</Typography>
            </StyledDiv>
            {mapQuestions()}
        </Stack>
        <Footer />
    </React.Fragment>
}